<template>
    <div class="Summary">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>Church Info</h4>
                        <p><span class="bold">Name: </span><span>{{ RecordData.Name }}</span></p>
                        <p><span class="bold">Territory: </span><span>{{ RecordData.SubProgramTerritory.Name }}</span></p>
                        <p><span class="bold">Denomination: </span><span>{{ RecordData.Denomination }}</span></p>
                        <p><span class="bold">Website: </span><a :href="RecordData.Website">{{ RecordData.Website }}</a></p>
                        <p><span class="bold">Address: </span><span>{{ RecordData.PhysicalAddress.AddressSingleLine }}</span> <GoogleMapsLink v-bind:address="RecordData.PhysicalAddress" /></p>
                    </div>
                    
                </div>
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>People</h4>
                        <div v-if="CurrentTeamMembers">
                            <p><span class="bold">Pastor: </span><span>{{ CurrentTeamMembers.Pastors }}</span></p>
                            <p><span class="bold">Ministry Lead: </span><span>{{ CurrentTeamMembers.MinistryLeads }}</span></p>
                            <p><span class="bold">Family Coach: </span><span>{{ CurrentTeamMembers.FamilyCoaches }}</span></p>
                            <p><span class="bold">Other Staff: </span><span>{{ CurrentTeamMembers.OtherStaff }}</span></p>
                        </div>
                        <div v-else>
                            <p><span class="bold red">Client is pending a team assignment.  Assign the client to a Team in the Team Tab.</span></p>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GoogleMapsLink from "../../../../Core/LinkShortcuts/GoogleMapsLink.vue";
    export default {
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                
            }
        },
        methods: {
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            
        },
        components: {
            GoogleMapsLink
        },
        mounted() {
        },
        computed: {
            CurrentTeamMembers: function () {
                let output = {
                    Pastors: "Unassigned",
                    MinistryLeads: "Unassigned",
                    FamilyCoaches: "Unassigned",
                    OtherStaff: "Unassigned",
                };


                let pastorsList = this.RecordData.ChurchContacts.filter(r => r.EndDate == null && r.Role == "Pastor");
                if (pastorsList.length > 0) {
                    output.Pastors = pastorsList.map(cc => cc.Person.FullName).join(', ');
                }
                let ministryleadsList = this.RecordData.ChurchContacts.filter(r => r.EndDate == null && r.Role == "Ministry Lead");
                if (ministryleadsList.length > 0) {
                    output.MinistryLeads = ministryleadsList.map(cc => cc.Person.FullName).join(', ');
                }
                let familyCoachesList = this.RecordData.ChurchContacts.filter(r => r.EndDate == null && r.Role == "Family Coach");
                if (familyCoachesList.length > 0) {
                    output.FamilyCoaches = familyCoachesList.map(cc => cc.Person.FullName).join(', ');
                }
                let otherStaffList = this.RecordData.ChurchContacts.filter(r => r.EndDate == null && r.Role == "Other Staff");
                if (otherStaffList.length > 0) {
                    output.OtherStaff = otherStaffList.map(cc => cc.Person.FullName).join(', ');
                }

                return output;
                
            }
        }
    }
</script>

<style scoped>
</style>